import axios from 'axios'
import store from '@/common/GlobalStore'

const download = (fileId,fileType) => {
  var data = {}
  var url = ''
  if (!fileType) {
    data = {
      'resourceId': fileId
    }
    url = '/resource/download'
  } else {
    data ={ 
      "objData1":{
          "instance_id":fileId,
          "type":fileType
        }
      }
    url = '/resource/downloadWord'
  }
  axios({
    url,
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    var A = ''
    if (!fileType) {
       A = store.getters.pageData.axiosHeader['content-disposition'].split('fileName=')[1]
    }else {
      A = store.getters.pageData.axiosHeader['content-disposition'].split('filename= ')[1]
    }
    var FileSaver = require('file-saver')
    FileSaver.saveAs(new Blob([res]), decodeURIComponent(A))
  })
}


export default {
  download, 
}


// WEBPACK FOOTER //
// ./src/util/downLoad.js